<header [ngClass]="{'scrolled': isScrolled}"
  class="fixed w-full top-0 left-0 z-50 transition-all duration-300 border-b">
  <div class="max-w-7xl mx-auto flex justify-between items-center px-4 sm:px-6 py-3">

    <!-- Logo -->
    <a routerLink="/" class="flex items-center">
      <img src="/SrieeHoldings-logo-v2.png" alt="Sriee Holdings Logo" class="h-10 sm:h-12 w-auto object-contain" />
    </a>

    <!-- Desktop Nav -->
    <nav class="hidden lg:flex space-x-6 font-medium text-sm">
      <a href="#about" [ngClass]="getLinkClasses('about')">About Us</a>
      <a href="#sectors" [ngClass]="getLinkClasses('sectors')">Emerging Sectors</a>
      <a href="#deliver" [ngClass]="getLinkClasses('deliver')">What We Deliver</a>
      <a href="#why" [ngClass]="getLinkClasses('why')">Why Sriee Holdings?</a>
      <!-- <a href="#partnership" [ngClass]="getLinkClasses('partnership')">Partnership & Network</a> -->
      <!-- <a href="#presence" [ngClass]="getLinkClasses('presence')">Global Presence</a> -->
      <a *ngIf="showPartnership" href="#partnership" [ngClass]="getLinkClasses('partnership')">
        Partnership & Network
      </a>
      <a *ngIf="showPresence" href="#presence" [ngClass]="getLinkClasses('presence')">
        Global Presence
      </a>
    </nav>


    <!-- Contact + Hamburger -->
    <div class="flex items-center gap-3">
      <a href="#contact" class="px-3 sm:px-5 py-2 text-sm sm:text-base rounded-lg shadow transition" [ngClass]="isScrolled 
          ? 'bg-[#0C3156] text-white hover:bg-[#F5A623] hover:text-[#0C3156]' 
          : 'bg-[#F5A623] text-white hover:bg-white hover:text-[#0C3156]'">
        Contact
      </a>
      <button (click)="isMenuOpen = !isMenuOpen" class="lg:hidden focus:outline-none" [ngClass]="
    currentRoute === '/' 
      ? 'text-[#0C3156]' 
      : (isScrolled ? 'text-[#0C3156]' : 'text-gray-600')
  ">
        <!-- Icons -->
        <svg *ngIf="!isMenuOpen" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 sm:h-7 sm:w-7" fill="none"
          viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
        <svg *ngIf="isMenuOpen" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 sm:h-7 sm:w-7" fill="none"
          viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>

    </div>
  </div>

  <!-- Mobile Dropdown -->
  <!-- <div *ngIf="isMenuOpen" class="lg:hidden px-6 py-4 space-y-3 shadow"
    [ngClass]="isScrolled ? 'bg-white text-[#0C3156]' : 'bg-black/70 text-white backdrop-blur-md'">
    <a href="#about" class="block hover:text-[#F5A623]">About Us</a>
    <a href="#sectors" class="block hover:text-[#F5A623]">Emerging Sectors</a>
    <a href="#deliver" class="block hover:text-[#F5A623]">What We Deliver</a>
    <a href="#why" class="block hover:text-[#F5A623]">Why Sriee Holdings?</a>
    <a href="#partnership" class="block hover:text-[#F5A623]">Partnership & Network</a>
    <a href="#presence" class="block hover:text-[#F5A623]">Global Presence</a>
  </div> -->


  <div *ngIf="isMenuOpen" class="lg:hidden flex flex-col space-y-4 py-4 shadow">
    <a href="#about" (click)="closeMenu()" [ngClass]="getLinkClasses('about')" class="px-4">About Us</a>
    <a href="#sectors" (click)="closeMenu()" [ngClass]="getLinkClasses('sectors')" class="px-4">Emerging Sectors</a>
    <a href="#deliver" (click)="closeMenu()" [ngClass]="getLinkClasses('deliver')" class="px-4">What We Deliver</a>
    <a href="#why" (click)="closeMenu()" [ngClass]="getLinkClasses('why')" class="px-4">Why Sriee Holdings?</a>
    <!-- <a href="#partnership" (click)="closeMenu()" [ngClass]="getLinkClasses('partnership')" class="px-4">Partnership & Network</a> -->
    <!-- <a href="#presence" (click)="closeMenu()" [ngClass]="getLinkClasses('presence')" class="px-4">Global Presence</a> -->

    <a *ngIf="showPartnership" href="#partnership" (click)="closeMenu()" [ngClass]="getMobileLinkClasses('partnership')"
      class="px-4">
      Partnership & Network
    </a>
    <a *ngIf="showPresence" href="#presence" (click)="closeMenu()" [ngClass]="getMobileLinkClasses('presence')"
      class="px-4">
      Global Presence
    </a>
  </div>
</header>